module.exports = __webpack_public_path__ + "img/98.1.12642b64.jpg";